import { NgModule } from '@angular/core';
import { Checkbox } from './checkbox';
import { FormsModule } from '@angular/forms';

@NgModule({
    declarations: [Checkbox],
    exports: [Checkbox],
    imports: [FormsModule],
})
export class CheckboxModule {
}